import {
  GroupAPIResponse,
  GroupCreateAPI,
  GroupCreateAPIResponse,
  GroupWithComposableDevice,
} from './group.model';
import getGroupsListFromGroupsTree from './serialize/getGroupsListFromGroupsTree';
import { toBase64 } from '../../shared/util/base64';
import LocationAPI from '../locations/LocationAPI';
import Environment from '../../shared/constants/Environment';

const GroupAPI = LocationAPI.injectEndpoints({
  endpoints(build) {
    return {
      getGroupsList: build.query<GroupAPIResponse[], void>({
        query: () => ({
          url: `${Environment.backendGroupsAPI}/`,
          method: 'get',
        }),
        transformResponse: (response: GroupAPIResponse[]) => {
          return getGroupsListFromGroupsTree(response);
        },
      }),
      getGroupById: build.query<GroupWithComposableDevice, string>({
        query: (id) => ({
          url: `${Environment.backendGroupsAPI}/${toBase64(id)}`,
          method: 'get',
        }),
        transformResponse: (response: GroupWithComposableDevice) => {
          return response;
        },
        providesTags: ['locations-actions'],
      }),
      createGroup: build.mutation<GroupCreateAPIResponse, GroupCreateAPI>({
        query: (data) => ({
          url: Environment.backendGroupsAPI,
          method: 'post',
          data,
        }),
        invalidatesTags: ['group-actions'],
      }),
      updateGroup: build.mutation<
        Partial<GroupWithComposableDevice>,
        { id: string; data: Partial<GroupWithComposableDevice> }
      >({
        query: ({ id, data }) => ({
          url: `${Environment.backendGroupsAPI}/${toBase64(id)}`,
          method: 'put',
          data,
        }),
        invalidatesTags: ['group-actions'],
      }),
    };
  },
});

export default GroupAPI;

export const { useGetGroupsListQuery, useGetGroupByIdQuery } = GroupAPI;
